import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { makeStyles, Grid, Chip } from '@material-ui/core';
import {
  Panel,
  Typography,
  Loader,
  List,
  IllustrationInfo,
  IconButton,
  ListButton,
} from 'components';
import { useReduxDispatch, useReduxSelector } from 'store/hooks';
import { fetchHolidays } from 'store/holiday';
import { fetchShiftMaster } from 'store/shiftMaster';
import HolidayDetail from './HolidayDetail';
import FilterDateDialog from './FilterDateDialog';
import AddHolidayDialog from './AddHolidayDialog';
import EditHolidayDialog from './EditHolidayDialog';

export default React.memo((props) => {
  const classes = useStyles();
  const holidayList = useReduxSelector((state) => state.holiday);
  const shiftMaster = useReduxSelector((state) => state.shiftMaster);
  const getHolidayList = useReduxDispatch(fetchHolidays);
  const getshiftMaster = useReduxDispatch(fetchShiftMaster);

  const [selected, setSelected] = useState({});
  const [action, setAction] = useState();
  const [openAddHolidayDialog, setOpenAddHolidayDialog] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [draftEdit, setDraftEdit] = useState({});
  const [openFilterDate, setOpenFilterDate] = useState(false);
  const [filterStartDate, setFilterStartDate] = useState();
  const [filterEndDate, setFilterEndDate] = useState();

  const onChange = (key, value) => setDraftEdit({ ...draftEdit, [key]: value });

  useEffect(() => {
    if (holidayList.isIdle) {
      getHolidayList();
    }
  }, [getHolidayList, holidayList.isIdle]);

  useEffect(() => {
    if (shiftMaster.isIdle) {
      getshiftMaster();
    }
  }, [shiftMaster.isIdle, getshiftMaster]);

  const getLabelFilterDate = () => {
    if (!filterStartDate && !filterEndDate) {
      return 'Tanggal: Semua';
    }
    return `Tanggal: ${filterStartDate ? moment(filterStartDate).format('DD MMM YYYY') : ''} ${
      filterEndDate ? '- ' + moment(filterEndDate).format('DD MMM YYYY') : '- Akhir'
    }`;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={action === 'view' ? 9 : 12} md={5}>
        <Panel>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h5" style={{ fontSize: 32, fontWeight: 800, marginRight: 12 }}>
              Daftar Hari Libur
            </Typography>
            <ListButton icon="plus" onClick={() => setOpenAddHolidayDialog(true)}>
              Tambah
            </ListButton>
          </div>
          <Chip
            clickable
            aria-haspopup="true"
            size="small"
            label={getLabelFilterDate()}
            color="primary"
            variant="outlined"
            style={{ marginRight: 6, marginBottom: 8, padding: 8 }}
            onClick={() => setOpenFilterDate(true)}
          />
          {holidayList.isReady && holidayList.data?.length > 0 ? (
            <List
              list={holidayList.data.filter((e) => {
                const date =
                  filterStartDate && filterEndDate
                    ? e.startDate >= filterStartDate && e.endDate <= filterEndDate
                    : filterStartDate
                    ? e.endDate >= filterStartDate
                    : true;
                return date;
              })}
              type="card"
              pagingType="full"
              withoutSelectArea
              cardMarginBottom={4}
            >
              {(item) => (
                <div style={{ width: '100%' }}>
                  <div className={classes.rootList}>
                    <div className={classes.detailContainer}>
                      <div>
                        <Typography variant="body1">
                          {moment(item.startDate).format('D MMMM YYYY')}
                          {' - '}
                          {moment(item.endDate).format('D MMMM YYYY')}
                        </Typography>
                        <Typography
                          variant="body1"
                          type="bold"
                          style={{ textTransform: 'uppercase', color: '#222' }}
                        >
                          {item.title}
                        </Typography>
                      </div>
                      <div className={classes.actionContainer}>
                        <IconButton
                          icon="edit"
                          color="#A5B3BA"
                          onClick={() => {
                            setIsEditOpen(true);
                            setDraftEdit(item);
                            setAction('');
                          }}
                        />
                        <IconButton
                          icon="chevron-right"
                          color="#A5B3BA"
                          onClick={() => {
                            setAction('view');
                            setSelected(item);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </List>
          ) : holidayList.isFetching ? (
            <Loader height={300} variant="clip" />
          ) : (
            <IllustrationInfo width={150} />
          )}
        </Panel>
      </Grid>
      {action && (
        <HolidayDetail
          selected={selected}
          setSelected={setSelected}
          shiftMaster={shiftMaster}
          setAction={setAction}
        />
      )}
      <FilterDateDialog
        filterEndDate={filterEndDate}
        filterStartDate={filterStartDate}
        openFilterDate={openFilterDate}
        setOpenFilterDate={setOpenFilterDate}
        setFilterStartDate={setFilterStartDate}
        setFilterEndDate={setFilterEndDate}
      />
      <AddHolidayDialog open={openAddHolidayDialog} close={setOpenAddHolidayDialog} />
      <EditHolidayDialog
        isEditOpen={isEditOpen}
        onCloseEdit={setIsEditOpen}
        draftEdit={draftEdit}
        onChangeDraft={onChange}
      />
    </Grid>
  );
});

const useStyles = makeStyles((theme) => ({
  rootList: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  detailContainer: {
    marginLeft: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'calc(100% - 30px)',
  },
  buttonView: {
    padding: '2px 10px',
    borderRadius: 25,
    backgroundColor: '#c2e1fb',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: 5,
  },
  actionContainer: {
    gap: 8,
    display: 'flex',
    justifyContent: 'center',
  },
}));
